import type {IWindowService} from 'angular';

export class UserFeedbackService {
    public static serviceName = 'userFeedbackService';

    private audioContext: AudioContext = null;

    /*@ngInject*/
    constructor(private $window: IWindowService) {
    }

    public beep(durationInMillis: number = 200): void {
        if (!this.audioContext) { // invoking audio ctx ctor before any user action results in browser warning => cannot invoke in service ctor
            const AudioContextCtor = this.$window.AudioContext || this.$window.webkitAudioContext; // cross-browser support because of safari :-(
            this.audioContext = new AudioContextCtor();
        }
        this.generateSound(2, 880, durationInMillis, 'square');
    }

    public vibrate(durationInMillis: number = 250): void {
        if (this.isVibrationSupported()) {
            this.$window.navigator.vibrate(durationInMillis);
        }
    }

    public isVibrationSupported(): boolean {
        return this.$window.navigator.vibrate && typeof this.$window.navigator.vibrate === 'function';
    }

    private generateSound(volume: number, frequency: number, duration: number, waveform: Waveform) {
        const oscillator = this.audioContext.createOscillator();
        const gain = this.audioContext.createGain();

        oscillator.connect(gain);
        oscillator.frequency.value = frequency;
        oscillator.type = waveform;

        gain.connect(this.audioContext.destination);
        gain.gain.value = volume * 0.01;

        oscillator.start(this.audioContext.currentTime);
        oscillator.stop(this.audioContext.currentTime + duration * 0.001);
    }
}

type Waveform = 'sine' | 'square' | 'sawtooth' | 'triangle';